import { ViewModel, View } from "binder"
import { ToolStatusEditorView } from "./toolStatusEditor-view"
import { IToolStatus } from "../IToolStatus";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";

export class ToolStatusEditorViewModel extends ViewModel implements IToolStatus, IPopup {
    constructor(parentViewModel: ViewModel, updater: IServerUpdater) {
        super(parentViewModel);
        this._serverUpdater = updater;
    }
    GetDefaultView(): View<ViewModel> {
        return new ToolStatusEditorView();
    }
    public getTypeId(): string {
        return "VM-B9851D7E-C630-4CA9-A6B6-0696A9DBA3A9"
    }

    private _serverUpdater: IServerUpdater;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name; } private _name: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code; } private _code: string;
    public set force(v: boolean) { this._force = v; } public get force(): boolean { return this._force; } private _force: boolean;

    closePopup(result?: any) {

    }

    async cloneTo(toolStatus: IToolStatus) {
        toolStatus.id = this.id;
        toolStatus.name = this.name;
        toolStatus.code = this.code;
    }

    back() {
        this.closePopup(null);
    }

    async save() {
        let verificationResult = this.verify();
        if (verificationResult.length > 0) {
            this.messageBoxConfirmWarning(verificationResult.join('\n'), 'خطا در ثبت وضعیت ابزار');
            return;
        } else {
            try {
                this.isLoading = true;
                let result = await this._serverUpdater.execute(this, false);
                if (result.IsSuccessful == false) {
                    if (result.Faults[0].Parameters.FaultId == '0444EA07-B96F-44B0-9432-47851CEB6078') {
                        await this.messageBoxConfirmWarning('اطلاعات به اشتباه وارد شده است.', 'خطا در عملیات');
                    }
                    else if (result.Faults[0].Parameters.FaultId == '096473E7-67AE-4206-9B61-79B70943684A') {
                        await this.messageBoxConfirmWarning('امکان ثبت کد وضعیت تکراری وجود ندارد.', 'خطا در عملیات');
                    }
                    else if (result.Faults[0].Parameters.FaultId == '73A6DD73-218E-44A1-939D-EFC98A3E9997') {
                        let isForce = await this.messageBoxWarningYesNo('آیا تغییرات مورد نظر اعمال شود؟', 'ویرایش');
                        if (isForce == 'yes') {
                            await this._serverUpdater.execute(this, true);
                            await this.messageBoxConfirmSuccess('وضعیت ابزار با موفقیت ثبت شد.', 'ثبت موفق');
                            this.closePopup('done');
                        }
                    }
                }
                else {
                    await this.messageBoxConfirmSuccess('وضعیت ابزار با موفقیت ثبت شد.', 'ثبت موفق');
                    this.closePopup('done');
                }
            }
            catch (ex) {
                await this.messageBoxConfirmWarning('خطا در ثبت وضعیت ابزار', 'خطا در عملیات');
                console.log(ex);
            } finally {
                this.isLoading = false;
            }
        }
    }

    verify(): string[] {
        let result: string[] = [];
        if (stringIsNullOrEmpty(this.name)) {
            result.push('شرح وضعیت ابزار مشخص نشده است.');
        }
        if (stringIsNullOrEmpty(this.code)) {
            result.push('کد وضعیت مشخص نشده است.');
        }
        return result;
    }
}

export interface IServerUpdater {
    execute(toolStatus: IToolStatus, isForce: boolean): Promise<any>;
}

export class ToolStatusInserter implements IServerUpdater {
    async execute(toolStatus: IToolStatus): Promise<any> {
        try {
            let result = await ServerConnection.callServer('/Complex/ToolStatusServices/CreateToolStatus', {
                Name: toolStatus.name,
                Code: toolStatus.code
            });
            return result;
        } catch (ex) {
            throw ex;
        }
    }
}

export class ToolStatusUpdater implements IServerUpdater {
    async execute(toolStatus: IToolStatus, isForce): Promise<any> {
        try {
            let result = await ServerConnection.callServer('/Complex/ToolStatusServices/UpdateToolStatus', {
                ToolStatusId: toolStatus.id,
                Name: toolStatus.name,
                Code: toolStatus.code,
                Force: isForce
            });
            return result;
        } catch (ex) {
            throw ex;
        }
    }
}
